import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  grid: {
    margin: "24px 0 0 0",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "24px -32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "24px -16px",
    },
    "& .rdt_TableRow": {
      "& >div:last-child": {
        position: "relative !important",
        right: "0px",
        backgroundColor: "inherit",
      }
    },
    "& .rdt_TableCell": {
      paddingLeft: "16px",
      paddingRight: "16px",
    },
    "& .rdt_TableCol": {
      paddingLeft: "16px",
      paddingRight: "16px",
      whiteSpace: "nowrap"
    },
    "& .rdt_TableCell:last-child": {
      paddingRight: "16px"
    },
  }
}));

export default styles;